import { createFileRoute, redirect } from "@tanstack/react-router";
import { requireMe } from "../features/auth/guard";

/** "/" sends people where they belong: their first workspace's inbox, or onboarding. */
export const Route = createFileRoute("/")({
  beforeLoad: async ({ context }) => {
    const me = await requireMe(context.queryClient, "/");
    const first = me.memberships[0];
    if (!first) throw redirect({ to: "/onboarding/workspace" });
    throw redirect({ to: "/w/$slug/inbox", params: { slug: first.workspaceSlug } });
  },
});
